import { render, staticRenderFns } from "./OpenEmailVerifyModal.vue?vue&type=template&id=0acc704c&scoped=true"
import script from "./OpenEmailVerifyModal.vue?vue&type=script&lang=js"
export * from "./OpenEmailVerifyModal.vue?vue&type=script&lang=js"
import style0 from "./OpenEmailVerifyModal.vue?vue&type=style&index=0&id=0acc704c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acc704c",
  null
  
)

export default component.exports